
export default {
    vi: {
        searchPlaceholder: 'Tìm kiếm',
        home: 'Trang chủ',
        lesson: 'Bài học',
        course: 'Khóa học',
        question: 'Thảo luận',
        notification: 'Thông báo',
        message: 'Tin nhắn',
        profile: 'Hồ sơ',
    },
    en: {
        searchPlaceholder: 'Search',
        home: 'Home page',
        lesson: 'Lesson',
        course: 'Course',
        question: 'Question',
        notification: 'Notification',
        message: 'Message',
        profile: 'Profile',
    }
}

